import styled, { css } from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	border-bottom: 1px solid ${colors.grey3};

	&:first-child {
		border-top: 1px solid ${colors.grey3};
	}
`;

export const Header = styled.div`
	display: flex;
	align-items: center;
	cursor: default;
`;

export const HeaderLabel = styled.div`
	display: flex;
	color: ${colors.grey7};
	font-size: 19px;
	line-height: 27px;
	padding: 10px;
`;

export const SubheaderLabel = styled.div`
	display: flex;
	color: ${colors.grey5};
	font-size: 13px;
	line-height: 19px;
	letter-spacing: 0.3px;
	padding: 0 6px;
`;

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	padding: 0 0 16px 39px;
`;

export const IconWrapper = styled.div`
	display: flex;
	cursor: pointer;
	transition: 0.15s transform ease-in-out;
	margin-right: 5px;

	${({ isCollapsed }) =>
		!isCollapsed &&
		css`
			transform: rotate(90deg);
		`};
`;
